import { useEffect, useState } from "react";
import type { Dispatch } from "react";

export function useStickyState<T>(
  defaultValue: T,
  key: string,
): [T, Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = useState(() => {
    const stickyValue = window.localStorage.getItem(key);
    if (stickyValue === null) {
      return defaultValue;
    }
    try {
      return JSON.parse(stickyValue);
    } catch {
      // The stored value predates JSON serialization or was otherwise
      // corrupted. Fall back to the default rather than crashing the app; the
      // effect below will overwrite it with a well-formed value.
      return defaultValue;
    }
  });

  useEffect(() => {
    window.localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}
